import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  closeIcon: { marginRight: 4, paddingBottom: 2 },
  buttonsContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    [theme.breakpoints.downLandscape('sm')]: {
      ...(theme.isMobileDevice && {
        paddingBottom: theme.spacing(1.5),
        paddingTop: theme.spacing(1.5),
      }),
    },
  },
}));
